module.exports = __webpack_public_path__ + "img/icon_time_24.7637eb90.svg";